var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09375 0.5C2.27324 0.5 1.48633 0.825948 0.906138 1.40614C0.325948 1.98633 0 2.77324 0 3.59375V13.1562C0 13.9768 0.325948 14.7637 0.906138 15.3439C1.48633 15.9241 2.27324 16.25 3.09375 16.25H19.4062C20.2268 16.25 21.0137 15.9241 21.5939 15.3439C22.1741 14.7637 22.5 13.9768 22.5 13.1562V3.59375C22.5 2.77324 22.1741 1.98633 21.5939 1.40614C21.0137 0.825948 20.2268 0.5 19.4062 0.5H3.09375Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 18.7812C3.375 18.5575 3.46389 18.3429 3.62213 18.1846C3.78036 18.0264 3.99497 17.9375 4.21875 17.9375H18.2812C18.505 17.9375 18.7196 18.0264 18.8779 18.1846C19.0361 18.3429 19.125 18.5575 19.125 18.7812C19.125 19.005 19.0361 19.2196 18.8779 19.3779C18.7196 19.5361 18.505 19.625 18.2812 19.625H4.21875C3.99497 19.625 3.78036 19.5361 3.62213 19.3779C3.46389 19.2196 3.375 19.005 3.375 18.7812Z",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.0ef193a4.svg";
export { ForwardRef as ReactComponent };